<div *ngIf="fleets && fleets.length > 0" class="global-search">
	<div class="form-group row">
		<label class="col-sm-4">Search all fleets / assets:</label>
		<div class="col-sm-8">
			<input [ngModel]="searchText | formatSearchable" (ngModelChange)="searchText = $event" [ngbTypeahead]="searchFunc" [editable]="false" [resultFormatter]="searchFormat"
				(selectItem)="searchNav($event.item)" type="text" class="form-control">
		</div>
	</div>
</div>
<div *ngIf="api.user?.role !== 'admin' && api.user?.role !== 'master'">
	<nav class="breadcrumb">
		<span class="breadcrumb-item active">My {{brand.fleetPlural}}</span>
	</nav>
	<app-fleet-summary [routerLink]="['fleet', fleet.fleet_id]" [fleet]="fleet" *ngFor="let fleet of fleets" class="clickable"></app-fleet-summary>
	<div *ngIf="fleets && fleets.length === 0" class="no-fleets">You have no {{brand.fleetPlural | lowercase}} to view</div>
</div>
<div *ngIf="api.user?.role === 'admin' || api.user?.role === 'master'">
	<div *ngFor="let org of orgs">
		<nav class="breadcrumb">
			<span class="breadcrumb-item active">{{org.name}} {{brand.fleetPlural}}</span>
		</nav>
		<app-fleet-summary [routerLink]="['fleet', fleet.fleet_id]" [fleet]="fleet" *ngFor="let fleet of org.fleets" class="clickable"></app-fleet-summary>
		<div *ngIf="org.fleets && org.fleets.length === 0" class="no-fleets">You have no {{brand.fleetPlural | lowercase}} to
			view</div>
	</div>
</div>